export enum TaskTypes {
    ConfirmCall = 'Confirm Call',
    NoShow = 'No Show',
    AppointmentCancellation = 'Appointment Cancellation',
    AppointmentNotPurchased = 'Not Purchased',
    CustomerContact = 'Customer Contact',
    EndOfDay = 'End of Day',
    ReadyToTrade = 'Ready to Trade'
}
